module.exports = __webpack_public_path__ + "pcsg/img/pearflot.cb5ab07c.jpg";